import { colors } from './colors';
import chroma from 'chroma-js';

export const semantic_colors = {
  background: {
    base: colors.gray30,
    surface: colors.white,
    elevated: colors.white,
    disabled: colors.gray10,
    surface_inverse: colors.gray800,
    scrim: chroma(colors.black).alpha(0.4).hex(),
  },
  fill: {
    primary: colors.gray150,
    secondary: colors.gray30,
    tertiary: colors.gray20,
    disabled: colors.gray10,
    primary_inverse: colors.gray970,
  },
  border: {
    primary: colors.gray50,
    secondary: colors.gray80,
    active: colors.gray550,
    disabled: colors.gray50,
    primary_inverse: colors.white,
  },
  content: {
    primary: colors.gray800,
    secondary: colors.gray550,
    tertiary: colors.gray400,
    disabled: colors.gray150,
    primary_inverse: colors.white,
    quaternary: colors.gray200,
  },
  brand: {
    primary: colors.zigzag_pink500,
    light: colors.zigzag_pink100,
    disabled: colors.zigzag_pink200,
  },
  accent: {
    primary: colors.blue500,
    light: colors.blue50,
    disabled: colors.blue200,
  },
  state: {
    positive: colors.green500,
    positive_light: colors.green100,
    positive_disabled: colors.green200,
    warning: colors.orange400,
    warning_light: colors.orange50,
    warning_disabled: colors.orange150,
    negative: colors.red400,
    negative_light: colors.red50,
    negative_disabled: colors.red100,
  },
  static: {
    white: colors.white,
    black: colors.black,
  },
  tab_focus: colors.light_blue700,
  graph: {
    red_light: colors.red150,
    red: colors.red400,
    red_dark: colors.red700,
    blue_light: colors.blue300,
    blue: colors.blue500,
    blue_dark: colors.blue700,
    orange_light: colors.orange200,
    orange: colors.orange400,
    orange_dark: colors.orange600,
    purple_light: colors.purple300,
    purple: colors.purple500,
    purple_dark: colors.purple700,
    yellow_light: colors.yellow150,
    yellow: colors.yellow300,
    yellow_dark: colors.yellow600,
    pink_light: colors.zigzag_pink_new200,
    pink: colors.zigzag_pink_new400,
    pink_dark: colors.zigzag_pink_new600,
    green_light: colors.green300,
    green: colors.green500,
    green_dark: colors.green700,
    sky_blue_light: colors.light_blue200,
    sky_blue: colors.light_blue400,
    sky_blue_dark: colors.light_blue700,
  },
};
